import { Chip, ChipProps, Stack } from "@mui/material";
import {
  CompanyState,
  CompanyStateValues,
  OnboardingState,
  OnboardingStateValues,
} from "models/Company";

const CompanyStateColors: Record<CompanyState, ChipProps["color"]> = {
  ACTIVE: "info",
  NEW: "success",
  ARCHIVED: "warning",
  BLOCKED: "error",
};

const OnboardingStateColors: Record<OnboardingState, ChipProps["color"]> = {
  NOT_CONTACTED: "default",
  SUPPLIER_CERT_SENT: "warning",
  PENDING_APPROVAL: "success",
};

type CompanyStateChipProps = { state: CompanyState; onboardingState?: OnboardingState };

const CompanyStateChip: React.FC<CompanyStateChipProps> = (props) => {
  const { state, onboardingState } = props;

  return (
    <Stack direction="row" spacing={0.5} sx={{ display: "inline-flex" }}>
      <Chip
        size="small"
        label={CompanyStateValues[state] || "-"}
        color={CompanyStateColors[state]}
      />
      {state === "NEW" && onboardingState && (
        <Chip
          size="small"
          variant="outlined"
          label={OnboardingStateValues[onboardingState] || "-"}
          color={OnboardingStateColors[onboardingState]}
        />
      )}
    </Stack>
  );
};

export default CompanyStateChip;
